import React, { useState, useEffect } from 'react';

import { Legend, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import { appConfig } from '../config.js';
import { formatDatesInChartTiks } from '../Utils.js';


const KpiChart = ({ networkName, selectedCells, fromDate, toDate, token }) => {

    const [dataKpiChart, setDataKpiChart] = useState({});
    const [devices, setDevices] = useState([]);

    const baseURL = appConfig.api.URL;
    const strFromDate = dateToString(fromDate);
    const strToDate = dateToString(toDate);

    function dateToString(inDate) {
        let dateUTC = new Date(Date.UTC(inDate.getFullYear(), inDate.getMonth(), inDate.getDate()));
        let strDate = dateUTC.toISOString().slice(0, 10);
        return strDate;
    }

    useEffect(() => {
        let url = `${baseURL}/kpis/?date=${strFromDate}`;
        if (fromDate !== null) {
            url = `${baseURL}/kpis/?date=${strFromDate}`;
            if (toDate != null) {
                url = `${baseURL}/kpis/?network=${networkName}&from_date=${strFromDate}&to_date=${strToDate}`;
            }
        }
        if (selectedCells){
            url = `${url}&device_names=${selectedCells.join(',')}`;
        }

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then(results => results.json())
            .then(data => {
                /*
                dataKpi = {
                    "cs_earlangs": {
                        "2021-07-15: {
                            "VKH201-Mpanga": 95,
                            "VKH202-Test": 96,
                        }
                    }
                }
                */
                devices.length = 0;
                const dataKpi = {};
                for (let i = 0; i < data.length; i++) {
                    let kpi = data[i];
                    if(devices.indexOf(kpi.device_name) === -1) devices.push(kpi.device_name);
                    for (let column of columns) {
                        if (!dataKpi[column.field]) {
                            dataKpi[column.field] = {};
                        }
                        if (!dataKpi[column.field][kpi.date_kpi]) {
                            dataKpi[column.field][kpi.date_kpi] = { 'date_kpi': new Date(kpi.date_kpi) };
                        }
                        dataKpi[column.field][kpi.date_kpi][kpi.device_name] = parseFloat(kpi[column.field]);
                    }
                }
                setDevices(devices.sort());
                /*
                dataKpiChart = {
                    "cs_earlangs": [
                        {
                            "date_kpi": "2021-07-15:,
                            "VKH201-Mpanga": 95,
                            "VKH202-Test": 96,
                        }
                    ]
                }
                */
                if (Object.keys(dataKpi).length > 0) {
                    let dataKpiChart = {};
                    for (let column of columns) {
                        if (!dataKpiChart[column.field]) {
                            dataKpiChart[column.field] = [];
                        }
                        for (const [date, values] of Object.entries(dataKpi[column.field])) {
                            dataKpiChart[column.field].push(values);
                        }
                    }
                    console.log("dataKpiChart", dataKpiChart);
                    setDataKpiChart(dataKpiChart);
                }
            }
            )

    }, [networkName, selectedCells, fromDate, toDate])

    const columns = [
        { title: "CS Erlangs", field: "cs_erlangs" },
        { title: "Call Setup Success Rate (%)", field: "call_setup_success_rate" },
        { title: "Call Success Rate (%)", field: "call_success_rate" },
        { title: "SDCCH Drop (%)", field: "sdcch_drop" },
        { title: "TCH Drop Rate (%)", field: "tch_drop_rate" },
        { title: "SDCCH Blocking (%)", field: "sdcch_blocking" },
        { title: "TCH Blocking (%)", field: "tch_blocking" },
        { title: "Immediate Assignment Success Rate (%)", field: "imm_ass_proc_succ_rate" },
        { title: "Total Number of Calls", field: "total_number_of_calls" },
        { title: "Total Voice Calls In Minutes", field: "total_voice_calls_in_min" },
        { title: "DL PS Erlangs", field: "dl_ps_erlangs" },
        { title: "UL PS Erlangs", field: "ul_ps_erlangs" },
        { title: "Total Data Calls", field: "total_data_calls" },
        { title: "Total Downlink Data in KByte", field: "total_downlink_data_kb" },
        { title: "Downlink Data Throughput in Kbps", field: "downlink_data_through_kbs" },
        { title: "TBF Assignment Success Rate (%)", field: "tbf_assignment_success_rate" },
        { title: "Network Availability (%)", field: "availability" },
    ]

    const colors = [];
    for (let i=0; i<devices.length; i++){
        colors.push('#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6));
    }

    if(Object.keys(dataKpiChart).length === 0){
        return <div></div>
    }
    return (
        <div>
            {columns.map(column =>
                <div key={`${networkName}-${column.field}`}>
                    <div>{column.title}</div>
                    <LineChart
                        width={1000}
                        height={500}
                        data={dataKpiChart[column.field]}
                        margin={{ top: 20, right: 30, left: 20, bottom: 35 }}
                    >
                        <XAxis dataKey="date_kpi" tickFormatter={formatDatesInChartTiks} reversed />
                        <YAxis />
                        <Tooltip itemSorter={item => -item.value}/>
                        <Legend />
                        <CartesianGrid stroke="#f5f5f5" strokeDasharray="3 3" />
                        {devices.map((device, index) =>
                            <Line type="monotone" key={`${networkName}-${column.field}-${device}`} dataKey={device} stroke={colors[index]} activeDot={{ r: 5 }} />
                        )}
                    </LineChart>
                </div>
            )}
        </div>
    );
};

export default KpiChart;